import { useEffect } from "react";

export const META_DESC = "Capital deployed among the world's least-reached, so that there be no needy person among them.";

export function usePageMeta(page) {
  useEffect(() => {
    document.title = `Acts 4 Capital — ${page}`;
    let m = document.querySelector('meta[name="description"]');
    if (!m) {
      m = document.createElement("meta");
      m.name = "description";
      document.head.appendChild(m);
    }
    m.content = META_DESC;
  }, [page]);
}
